/**
 * Header component
 */

import {Link} from 'react-router-dom';
import {useAuthStore} from '@voxapilot/shared';
import {api} from '../../config/firebase';
import {ROUTES} from '../../config/constants';
import {useState} from 'react';

export function Header() {
  const {user, signOut} = useAuthStore();
  const [isSigningOut, setIsSigningOut] = useState(false);
  
  const handleSignOut = async () => {
    if (isSigningOut) return; // Prevent double-clicks
    
    try {
      setIsSigningOut(true);
      await signOut(api.session);
      // Navigation will happen via ProtectedRoute when isAuthenticated becomes false
    } catch (error) {
      console.error('Sign out error:', error);
      // Still set signing out to false so user can try again
      setIsSigningOut(false);
    }
  };

  return (
    <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to={ROUTES.HOME} className="flex items-center">
            <h1 className="text-xl font-bold text-gray-900 dark:text-white">
              VoxaPilot
            </h1>
          </Link>

          <div className="flex items-center gap-4">
            {user && (
              <>
                <span className="text-sm text-gray-700 dark:text-gray-300">
                  {user.displayName || user.email}
                </span>
                <button
                  onClick={handleSignOut}
                  disabled={isSigningOut}
                  className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSigningOut ? 'Signing out...' : 'Sign out'}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

